export default "__VITE_ASSET__94a7c73f__"